import * as React from 'react'
import StandardInput from '../../common/components/standard-input'
import Validation from '../../common/modules/validation/rules'
import Recaptcha from '../../common/components/recaptcha'
import StepTitle from '../../common/components/step-title'
import SubHeader from '../../common/components/sub-header'
import StepBlock from '../../common/components/step-block'
import CurrentProgress from '../../common/components/current-progress'
import Container from '../../common/components/container'
import Button from '../../common/components/button'
import InputField from '../../common/components/input-field'
import QueryString from 'query-string'
import { getQueryString } from '../../common/util'
import checkedOptions from '../../common/options/check-options'
import yesNoOptions from '../../common/options/yes-no-options'

import { withValidation } from '../../common/modules/validation'
import { withForm } from '../../common/modules/form'
import { withSubmission } from '../../common/modules/submission'
import { withNavigation } from '../../common/modules/navigation'
import { withRouteBlocker } from '../../common/modules/route-blocker'
import { withProductDataDefered } from '../../common/modules/product-data'
import { withScrollToTop } from '../../common/modules/scroll-to-top'
import { withConfig } from '../../common/modules/config'
import fieldsActions from '../../common/modules/fields/fields-actions';


export const formConfig = state => {
    const fields = state.fields
    
    return {
        rules: {
            "firstName":[
                Validation.enforce.required("Please enter your first name."),
            ],
            "surname":[
                Validation.enforce.required("Please enter your last name."),
            ],
            "email":[
                Validation.enforce.required("Please type a valid email address"),
                Validation.enforce.email("Please type a valid email address.")
            ],
            "phone":[],
            "recaptcha":[
                Validation.enforce.required(""),
            ]
        },

        options:{
           
            // "acceptPromotionalEmails": checkedOptions
        },

        predicates:{
            
        },
        inferred:{},
        
        transformOut: data => {
            const referenceCode = getQueryString().referenceCode ? getQueryString().referenceCode.trim() : "";
            return referenceCode
                ? { ...data, referenceCode }
                : data
        }

    }

}


@withSubmission
@withNavigation
@withValidation
@withRouteBlocker
@withProductDataDefered
@withScrollToTop
@withForm(formConfig)
export default class extends React.Component<any, any> {

    
    render() {
        const fields = this.props.fields;

        return ( 
            <div className="row">
                <StepTitle>Let's Get Started</StepTitle>
                <StepBlock>Tell Us About Your Personal Information.</StepBlock>
                <InputField field="firstName"               label="First Name" />
                <InputField field="surname"                 label="Last Name" />

                <SubHeader>How can we contact you</SubHeader>
                <InputField field="phone"     type="tel"           label="Phone"       placeholder="Optional"   description="Please include area code if you are providing a landline e.g. 0298765432" />
                <InputField field="email"     type="email"         label="Email"       description="This will allow us to forward you the quote and to retrieve it in the future." />

                {/* <InputField field="acceptPromotionalEmails" label={ <span>I consent to receiving promotional/marketing emails or advertisements from CHU and its subsidiaries</span>} /> */}
               
                <StepBlock>
                    <p>By continuing with this quote you agree that the right <a href ='https://www.chu.com.au/important-documents/' target="_blank"><strong>PDS</strong></a> has been made available to you; you have read and agree with our <a href='https://www.chu.com.au/privacy-policy/' target="_blank"><strong>Privacy Policy</strong></a>, <a href='https://www.chu.com.au/legal-notices/'  target="_blank"><strong>Legal Notices </strong></a> & <a href='https://www.chu.com.au/resource/duty-to-not-misrepresent'  target="_blank"><strong>Duty to not misrepresent </strong></a> and consent to receiving policy documents via electronic means and relevant CHU Underwriting Agencies marketing communications.</p>
                </StepBlock>

                <Recaptcha field="recaptcha" />

                { fields.recaptcha && 
                    <Button.Container>
                        <Button.Continue onClick={ this.validate.bind(this) } />
                    </Button.Container>
                }
            </div>
        )
    }


    validate(){
        this.props.actions.validation.validate( this.submit.bind(this) );
    }


    submit(){
        const endpoint = this.props.submission.endpoints.step1
        this.props.actions.submission.submit(endpoint, this.requestProductData.bind(this), [
            formConfig
        ] );
        
    }

    requestProductData(){
            //The reference code will cause a quote request to be prepopulated with data from a template.
            const referenceCode = getQueryString().referenceCode ? getQueryString().referenceCode.trim() : "";
            const token = this.props.fields.token;
            const endpoint1 = this.props.submission.endpoints.template;
            this.props.actions.submission.get(endpoint1+"?token="+ token, this.templatePrefill.bind(this), this.renameFields.bind(this));
        }

    renameFields(data){
        // The below variables are created to support the query parameters and prefill the form values.
        const queryString = getQueryString();
        const streetNumber = queryString.streetNumber;
        const streetName = queryString.streetName;
        const suburb = queryString.suburb;
        const state = queryString.state;
        const postcode = queryString.postcode;
        const propertyAge = queryString.propertyAge;
        const wallConstructionType = queryString.wallConstructionType;
        const roofConstructionType = queryString.roofConstructionType;
        const floorConstructionType = queryString.floorConstructionType;
        const aboveGroundFloor = queryString.aboveGroundFloor;
        const renovations = queryString.renovations;
        const occupancyType = queryString.occupancyType;
        const incomeGenerating = queryString.incomeGenerating;

        const externalDoorsDeadlocks = queryString.externalDoorsDeadlocks;
        const externalDoorsSecurityScreen = queryString.externalDoorsSecurityScreen;
        const externalWindowsKeylocks = queryString.externalWindowsKeylocks;
        const externalWindowsRollerShutter = queryString.externalWindowsRollerShutter;
        const externalWindowsSecurityScreen = queryString.externalWindowsSecurityScreen;
        const otherSecurity24HourMonitoredAlarm = queryString.otherSecurity24HourMonitoredAlarm;
        const otherSecurityLocalAlarm = queryString.otherSecurityLocalAlarm;
        const otherSecurityGatedCommunity = queryString.otherSecurityGatedCommunity;
        const otherSecurity24HourConcierge = queryString.otherSecurity24HourConcierge;
        const otherSecurityFixedHomeSafe = queryString.otherSecurityFixedHomeSafe;
        const retiredResidents = queryString.retiredResidents;

        if (streetNumber) data.situationStreetNumber = streetNumber;
        if (streetName) data.situationStreetName = streetName;
        if (suburb) data.situationSuburb = suburb;
        if (state) data.situationState = state;
        if (postcode) data.situationPostCode = postcode;
        // setting the strataFlag to true by default.
        data.strataFlag = true;
        if (propertyAge) data.propertyAge = propertyAge;
        if (wallConstructionType) data.wallConstructionType = wallConstructionType;
        if (roofConstructionType) data.roofConstructionType = roofConstructionType;
        if (floorConstructionType) data.floorConstructionType = floorConstructionType;
        if (aboveGroundFloor) { data.aboveGroundFloor = aboveGroundFloor.toUpperCase() === 'TRUE' }
        if (renovations) { data.renovations = renovations.toUpperCase() === 'TRUE' }
        if (occupancyType) data.occupancyType = occupancyType;
        if (incomeGenerating) { data.incomeGenerating = incomeGenerating.toUpperCase() === 'TRUE' }

        if (externalDoorsDeadlocks) { data.externalDoorsDeadlocks = externalDoorsDeadlocks.toUpperCase() === 'TRUE' }
        if (externalDoorsSecurityScreen) { data.externalDoorsSecurityScreen = externalDoorsSecurityScreen.toUpperCase() === 'TRUE' }
        if (externalWindowsKeylocks) { data.externalWindowsKeylocks = externalWindowsKeylocks.toUpperCase() === 'TRUE' }
        if (externalWindowsRollerShutter) { data.externalWindowsRollerShutter = externalWindowsRollerShutter.toUpperCase() === 'TRUE' }
        if (externalWindowsSecurityScreen) { data.externalWindowsSecurityScreen = externalWindowsSecurityScreen.toUpperCase() === 'TRUE' }
        if (otherSecurity24HourMonitoredAlarm) { data.otherSecurity24HourMonitoredAlarm = otherSecurity24HourMonitoredAlarm.toUpperCase() === 'TRUE' }
        if (otherSecurityLocalAlarm) { data.otherSecurityLocalAlarm = otherSecurityLocalAlarm.toUpperCase() === 'TRUE' }
        if (otherSecurityGatedCommunity) { data.otherSecurityGatedCommunity = otherSecurityGatedCommunity.toUpperCase() === 'TRUE' }
        if (otherSecurity24HourConcierge) { data.otherSecurity24HourConcierge = otherSecurity24HourConcierge.toUpperCase() === 'TRUE' }
        if (otherSecurityFixedHomeSafe) { data.otherSecurityFixedHomeSafe = otherSecurityFixedHomeSafe.toUpperCase() === 'TRUE' }
        if (retiredResidents) { data.retiredResidents = retiredResidents.toUpperCase() === 'TRUE' }

        return {
            ...data,
            coverageType: data.coverType,
            streetNumber: data.situationStreetNumber,
            streetName: data.situationStreetName,
            suburb: data.situationSuburb,
            state: data.situationState,
            postcode: data.situationPostCode
        }
    }

    templatePrefill(){
        this.props.actions.productData.requestProductData(this.proceed.bind(this))
    }

    proceed(){
        this.props.actions.navigation.changeRoute("/step-2")
    }

}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/contents/routes/step-1.tsx